import { CatHeading } from 'components/blocks-components';
import { useTranslations } from 'next-intl';

const KeyTitle = () => {
  const t = useTranslations();

  return (
    <>
      <CatHeading variant="headline" decorator className="d-md-none">
        {t('PLP_KEY')}
      </CatHeading>
      <CatHeading variant="title" decorator className="d-none d-md-block">
        {t('PLP_KEY')}
      </CatHeading>
    </>
  );
};

export default KeyTitle;
